@if (internalWorkerId() === 0) {
<div>
  <span>{{ 'UF-AssignEmployerObjectAddUserFirst' | translate }}</span>
</div>
}

@if (internalWorkerId() !== 0) {
<div>
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>{{ 'UF-AssignEmployerObjectListTitle' | translate }}</mat-card-title>
    </mat-card-header>

    <mat-card-content fxLayout="column" fxLayoutGap="12px">
      <mat-form-field appearance="outline" fxFill class="search-form-field">
        <mat-label>{{ 'Search' | translate }}</mat-label>
        <input matInput type="text" [formControl]="searchControl" />
        @if (searchControl.value) {
        <button mat-icon-button matSuffix type="button" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
        }
      </mat-form-field>
      <cdk-virtual-scroll-viewport class="viewport" [itemSize]="48" [minBufferPx]="480" [maxBufferPx]="960"
        (scrolledIndexChange)="onScrolledIndexChange($event)">
        <div class="row"
          *cdkVirtualFor="let item of assignedEmployerObjects$ | async; let i = index; trackBy: trackByEmployerObjectId">
          <div class="name" [title]="item?.Name">
            {{ item?.Name }}
          </div>

          <button mat-icon-button color="primary" (click)="confirmDeleteEmployerObject(item)" [disabled]="isMutating">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </cdk-virtual-scroll-viewport>

      @if (dataSource.isLoading$ | async) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }

      <mat-divider class="list-divider"></mat-divider>

      <form [formGroup]="addEmployerObjectForm" class="add-row">
        <mat-form-field appearance="outline" class="add-input">
          <mat-label>{{ 'EmployerObject' | translate }}</mat-label>
          <input type="text" matInput formControlName="employerObject" [matAutocomplete]="autoEmployerObject" />

          <mat-autocomplete autoActiveFirstOption #autoEmployerObject="matAutocomplete" [displayWith]="displayValue"
            (optionSelected)="onEmployerObjectSelected($event.option.value)">
            @for (item of addEmployerObjects$ | async; track item.Id) {
            <mat-option [value]="item">
              {{ item.Name }}
            </mat-option>
            }
          </mat-autocomplete>

          @if (addEmployerObjectForm.controls['employerObject'].invalid &&
          addEmployerObjectForm.controls['employerObject'].touched) {
          <mat-error>{{ 'InvalidField' | translate }}</mat-error>
          }
        </mat-form-field>

        <button mat-icon-button color="primary" type="button" (click)="addSelectedEmployerObject()"
          [disabled]="canAddEmployerObject === false || isMutating">
          <mat-icon>add_box</mat-icon>
        </button>
      </form>
    </mat-card-content>
  </mat-card>
</div>
}